export default __webpack_public_path__ + "static/media/icones-sidebar-mobile.693090be.svg";